module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_4-8f4caf5d900cd1ad196dc9b7c9c23cf9.svg";